const options = {
  5: "bg-sky-50/5",
  10: "bg-sky-50/10",
  25: "bg-sky-50/25",
  50: "bg-sky-50/50",
  75: "bg-sky-50/75",
  90: "bg-sky-50/90",
  100: "bg-sky-50",
};

const from = {
  5: "from-sky-50/5",
  10: "from-sky-50/10",
  25: "from-sky-50/25",
  50: "from-sky-50/50",
  75: "from-sky-50/75",
  90: "from-sky-50/90",
  100: "from-sky-50",
};

export default function getBackgroundSky50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
